export default __webpack_public_path__ + "static/media/phone-warm.5e689c9a.jpg";